import './GenericDatepicker.css';
import { GenericDatepickerBuilder } from './builders/GenericDatepickerBuilder.js';

/**
 * GenericDatepicker (v1)
 * A core, fluent date and time picker.
 * Built using native JavaScript Intl and Date APIs.
 *
 * This bundle expects:
 * - jQuery available on `window.jQuery` / `window.$`
 * - `GenericDateTime` available globally (typically via `public/lib/GenericDateTime.js`)
 */

if (typeof window !== 'undefined') {
  window.GenericDatepickerBuilder = GenericDatepickerBuilder;
}

const $ = typeof window !== 'undefined' ? window.jQuery : undefined;
if ($?.fn) {
  $.fn.genericDatepicker = function (optionsOrFn) {
    return this.each(function () {
      const $this = $(this);
      if (typeof optionsOrFn === 'function') {
        const builder = GenericDatepickerBuilder.create(this);
        optionsOrFn(builder);
        const instance = builder.build();
        $this.data('generic-datepicker', instance);
      }
    });
  };
}

export { GenericDatepickerBuilder };
